import { Component, OnInit, ViewChild, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../../services/storage-service';
import { AppUrl } from '../../appUrl';
import { DatePicker } from 'primeng/datepicker';
import moment from 'moment';
import { TranslateModule } from '../../shareds/translate/translate.module';
import { TranslateService } from '../../shareds/translate/translate.service';

@Component({
  selector: 'app-upload-payment',
  standalone: true,
  host: { ngSkipHydration: 'true' },
  imports: [CommonModule, FormsModule, DatePicker, TranslateModule],
  templateUrl: './upload-payment.component.html',
  styleUrls: ['./upload-payment.component.css']
})
export class UploadPaymentComponent implements OnInit {
  private router = inject(Router);
  private ac = inject(ActivatedRoute);
  private st = inject(StorageService);
  private http = inject(HttpClient);
  private translate = inject(TranslateService);

  @ViewChild('timePicker') timePicker!: any;

  today = new Date();
  private bookingId = '';
  private branchId = '';

  selectedFile = signal<File | null>(null);
  previewUrl = signal<string>('');
  transferDate: Date | null = null;
  transferTime: Date | null = null;
  amount = 0;

  submitLoading = signal(false);
  submitError = signal('');
  fileSizeError = signal('');

  ngOnInit() {
    const br = this.st.getSession('lastBookingResult');
    if (br) {
      const result = JSON.parse(br);
      this.bookingId = result?.id ?? result?.bookingId ?? '';
    }
    const bd = this.st.getSession('lastBookingData');
    if (bd) {
      const parsed = JSON.parse(bd);
      this.branchId = parsed?.branchId ?? '';
      this.amount = parsed?.totalPrice ?? 0;
    }
  }

  onFileSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    if (file.size > 1024 * 1024) {
      this.fileSizeError.set(this.translate.instant('ขนาดไฟล์ไม่เกิน 1 MB', 'upload-payment'));
      return;
    }
    this.fileSizeError.set('');
    this.selectedFile.set(file);

    const reader = new FileReader();
    reader.onload = (e) => this.previewUrl.set(e.target?.result as string);
    reader.readAsDataURL(file);

    input.value = '';
  }

  triggerFileInput() {
    document.getElementById('slipFileInput')?.click();
  }

  removeFile() {
    this.selectedFile.set(null);
    this.previewUrl.set('');
  }

  submit() {
    this.submitError.set('');
    if (!this.selectedFile()) {
      this.submitError.set('กรุณาอัพโหลดหลักฐานการชำระเงิน');
      return;
    }
    if (!this.transferDate) {
      this.submitError.set('กรุณาเลือกวันที่โอนเงิน');
      return;
    }
    if (!this.transferTime) {
      this.submitError.set('กรุณาเลือกเวลาที่โอนเงิน');
      return;
    }

    const formData = new FormData();
    formData.append('File', this.selectedFile()!);
    formData.append('Date', moment(this.transferDate).format('YYYY-MM-DD'));
    formData.append('Time', moment(this.transferTime).format('HH:mm'));
    formData.append('Amount', String(this.amount));

    this.submitLoading.set(true);

    this.http.put(`/api/Public/ReserveHotel/${this.bookingId}/Payment?BranchId=${this.branchId}`, formData).subscribe({
      next: () => {
        this.submitLoading.set(false);
        this.st.removeSession('bookingData');
        this.st.removeSession('customerInfo');
        this.st.removeSession('listRoomState');
        this.router.navigate(['/', AppUrl.booking_success, this.ac.snapshot.params['app-id']]);
      },
      error: (err) => {
        this.submitLoading.set(false);
        this.submitError.set(err?.error?.message ?? 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'); // แปลใน template (module 'api')
      },
    });
  }

  closeTimePicker() {
    if (this.timePicker) this.timePicker.overlayVisible = false;
  }

  toBack() {
    history.back();
  }
}
